import {downloadJsonAsCSV} from '../../csv/utils'
import {ColumnTitlesKeys} from '../tasksTable/configurationMenu/constants'
import messageResource from "../../messageResource"
import _ from "underscore"
import {TaskSortBy} from '../constants'
import {DateFormat} from '../../date_format'
import {arrayToMap} from '../../atUtils'
import {WorkflowStatusType} from '../../workflowStatus/constants'
import {columnValue, formatDate, formatPercent, formatTimeDecimal, nameWithArchivedMark} from '../../csv/format'

export function convertTaskListAndSaveAsCsv({projects, customers, tasks, billingTypes, workflowStatuses}, optionalColumns, customFieldsMap, isTWSEnabled, summaryRow) {
    const customerMap = arrayToMap(customers)
    const projectMap = arrayToMap(projects)
    const billingTypesMap = arrayToMap(billingTypes.list)
    const workflowStatusValueMap = {}
    const getWorkflowStatusValue = isTWSEnabled ? workflowStatusExtended : workflowStatusSimple
    workflowStatuses.forEach(item => workflowStatusValueMap[item.id] = getWorkflowStatusValue(item))

    const json = {
        columnNames: csvColumnNames(optionalColumns, customFieldsMap),
        columns: csvColumns(optionalColumns),
        table: csvRows(tasks, optionalColumns, customerMap, projectMap, billingTypesMap, workflowStatusValueMap, summaryRow)
    }
    let fileName = messageResource.getMessage("task.list.export_name.csv", [new DateFormat('MMM dd, yyyy').formatDate(window.currentUserTime())])
    downloadJsonAsCSV([json], fileName)
}

function csvColumnNames(optionalColumns, customFieldsMap) {
    return {
        customer: messageResource.getMessage("common.Customer"),
        project: messageResource.getMessage("common.Project"),
        task: messageResource.getMessage("common.Task"),
        status: messageResource.getMessage("task.list.task_status"),
        ...csvOptionalColumnNames(optionalColumns, customFieldsMap)
    }
}

function csvOptionalColumnNames(optionalColumns, customFieldsMap) {
    return _.object(optionalColumns, _.map(optionalColumns, (item) => {
        if (!!customFieldsMap[item])
            return customFieldsMap[item].title
        else
            return messageResource.getMessage(ColumnTitlesKeys[item])
    }))
}

function csvColumns(optionalColumns) {
    return ["customer", "project", "task", "status", ...optionalColumns]
}

function csvRows(tasks, optionalColumns, customerMap, projectMap, billingTypesMap, workflowStatusValueMap, summaryRow) {
    let result = _.map(tasks, (task) => {
        const customFields = task.customFieldsValues || {}
        const formattedTask = { ...task, ...customFields }
        return {
            customer: nameWithArchivedMark(customerMap[formattedTask.customerId]),
            project: nameWithArchivedMark(projectMap[formattedTask.projectId]),
            task: formattedTask.name,
            status: workflowStatusValueMap[formattedTask.workflowStatusId],
            ...csvMapOptionalColumns(optionalColumns, formattedTask, billingTypesMap)
        }
    })

    if (summaryRow) {
        result = [
            {
                [TaskSortBy.ESTIMATE]: _.isNumber(summaryRow.estimate) ? columnValue(summaryRow.estimate, formatTimeDecimal) : undefined,
                [TaskSortBy.SPENT_TIME]: columnValue(summaryRow.spentTime, formatTimeDecimal),
                [TaskSortBy.VARIANCE_MAN_HOURS]: (summaryRow.variance && _.isNumber(summaryRow.variance.duration)) ? columnValue(summaryRow.variance.duration, formatTimeDecimal) : undefined,
                [TaskSortBy.VARIANCE_PERCENTS]: (summaryRow.variance && _.isNumber(summaryRow.variance.percentage)) ? columnValue(summaryRow.variance.percentage, formatPercent) : undefined
            },
            ...result
        ]
    }

    return result
}

function csvMapOptionalColumns(optionalColumns, task, billingTypesMap) {
    let result = {}
    _.each(optionalColumns, (column) => {
        if (!!optionalColumnMapFormatter[column]) {
            result[column] = optionalColumnMapFormatter[column](task, billingTypesMap)
        } else {
            result[column] = columnValue(task[column], value => value)
        }
    })
    return result
}

const optionalColumnMapFormatter = {
    [TaskSortBy.DEADLINE]: (task) => columnValue(task.deadline, formatDate),
    [TaskSortBy.ESTIMATE]: (task) => columnValue(task.estimatedTime, formatTimeDecimal),
    [TaskSortBy.LAST_TRACKING_DATE]: (task) => columnValue(task.lastTTDate, formatDate),
    [TaskSortBy.TYPE_OF_WORK]: (task, billingTypesMap) => billingTypeColumnValue(billingTypesMap[task.typeOfWorkId]),
    [TaskSortBy.CREATION_DATE]: (task) => formatDate(task.creationTimestamp),
    [TaskSortBy.SPENT_TIME]: (task) => formatTimeDecimal(task.spentTime),
    [TaskSortBy.VARIANCE_MAN_HOURS]: (task) => columnValue(task.variance ? task.variance.duration : null, formatTimeDecimal),
    [TaskSortBy.VARIANCE_PERCENTS]: (task) => columnValue(task.variance ? task.variance.percentage : null, formatPercent),
}

function workflowStatusSimple(status) {
    return messageResource.getMessage(status.type === WorkflowStatusType.OPEN ? "task.status.open" : "task.status.completed")
}

function workflowStatusExtended(status) {
    const statusPrefix = workflowStatusSimple(status)
    return `${statusPrefix}: ${status.name}`
}

function billingTypeColumnValue(billingType) {
    const category = messageResource.getMessage(billingType.billable ? 'billing_type.billable' : 'billing_type.non_billable')
    return `${category}: ${billingType.name}`
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/exportCsv/utils.js